import { QueryClient, MutationCache } from '@tanstack/react-query'
import { QUERY_KEYS } from '@/services/queries/document_versions'

const isStaleDocumentVersionError = (error: unknown): boolean => {
  const errorObj = error as any
  if (!errorObj || typeof errorObj !== 'object') return false

  const is403 = errorObj.status === 403
  const messagePattern =
    /not allowed to.*unless document version is latest version/i

  const hasStaleVersionMessage =
    (errorObj.message && messagePattern.test(errorObj.message)) ||
    (errorObj.cause?.message && messagePattern.test(errorObj.cause.message))

  const causeIs403 = errorObj.cause?.status === 403

  return (is403 || causeIs403) && hasStaleVersionMessage
}

const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      console.log('[MutationCache] onError called', { error, mutation })

      if (isStaleDocumentVersionError(error)) {
        console.info(
          '[QueryClient] Detected stale document version error, invalidating document versions cache',
        )

        // Invalidate all document version queries
        // This causes isLatestDocumentVersion to recompute as false
        // and triggers the ReadOnlyBanner to appear
        void queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.DOCUMENT_VERSIONS],
        })
      }
    },
  }),
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: Infinity,
      throwOnError: true,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  },
})

export default queryClient
